import type { DealParticipant } from '@openx/types/deal';
import { useMemo } from 'react';

export const useIsDemandPartnerSelected = (dealParticipants: DealParticipant[]): boolean =>
  useMemo(() => dealParticipants?.some(participant => participant.demand_partner), [dealParticipants]);
